// src/pages/HullCleaningNewReportPage.jsx
import React, { useMemo, useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const cleaningMethods = [
  'Brushing',
  'Diving',
  'Robotic',
  'Ultrasonic',
  'Other'
];

const HullCleaningNewReportPage = () => {
  // Report No & CreatedAt
  const [reportNo] = useState(1);
  const createdAt = useMemo(
    () =>
      new Date().toLocaleString(undefined, {
        year:   'numeric',
        month:  'long',
        day:    'numeric',
        hour:   '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }),
    []
  );

  // Vessel list & selection
  const [vessels, setVessels]       = useState([]);
  const [selectedVessel, setSelectedVessel] = useState('');
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/ships`)
      .then(r => r.json())
      .then(setVessels)
      .catch(console.error);
  }, []);

  // Form state
  const [cleaningDate, setCleaningDate] = useState('');
  const [location,    setLocation]      = useState('');
  const [method,      setMethod]        = useState('');
  const [remarks,     setRemarks]       = useState('');

  // Submit handler (placeholder)
  const handleSubmit = e => {
    e.preventDefault();
    const payload = {
      reportNo,
      vesselId: selectedVessel,
      cleaningDate,
      location,
      method,
      remarks,
      createdAt: new Date().toISOString()
    };
    console.log('Submit hull‐cleaning report:', payload);
    // TODO: POST payload to your backend
  };

  return (
    <div className="container-fluid px-4 py-4">
      <h2 className="mb-1">Hull Cleaning Report No: {reportNo}</h2>
      <p className="text-muted mb-4">
        <strong>Created At:</strong> {createdAt}
      </p>

      <form onSubmit={handleSubmit}>
        <div className="row gx-3 gy-3 mb-4">
          {/* Vessel */}
          <div className="col-md-4">
            <label htmlFor="vessel" className="form-label fw-bold">
              Select Vessel
            </label>
            <select
              id="vessel"
              className="form-select"
              value={selectedVessel}
              onChange={e => setSelectedVessel(e.target.value)}
              required
            >
              <option value="">-- Select Vessel --</option>
              {vessels.map(v => (
                <option key={v._id} value={v._id}>
                  {v.vesselName}
                </option>
              ))}
            </select>
          </div>

          {/* Cleaning Date */}
          <div className="col-md-4">
            <label htmlFor="cleaningDate" className="form-label fw-bold">
              Cleaning Date & Time
            </label>
            <input
              id="cleaningDate"
              type="datetime-local"
              className="form-control"
              value={cleaningDate}
              onChange={e => setCleaningDate(e.target.value)}
              required
            />
          </div>

          {/* Location */}
          <div className="col-md-4">
            <label htmlFor="location" className="form-label fw-bold">
              Location
            </label>
            <input
              id="location"
              type="text"
              className="form-control"
              placeholder="e.g. Port of Singapore / Waypoint"
              value={location}
              onChange={e => setLocation(e.target.value)}
            />
          </div>
        </div>

        <div className="row gx-3 gy-3 mb-4">
          {/* Cleaning Method */}
          <div className="col-md-4">
            <label htmlFor="method" className="form-label fw-bold">
              Cleaning Method
            </label>
            <select
              id="method"
              className="form-select"
              value={method}
              onChange={e => setMethod(e.target.value)}
            >
              <option value="">-- Select Method --</option>
              {cleaningMethods.map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
          </div>

          {/* Remarks */}
          <div className="col-md-8">
            <label htmlFor="remarks" className="form-label fw-bold">
              Remarks
            </label>
            <textarea
              id="remarks"
              className="form-control"
              rows="3"
              placeholder="Any observations, fouling level, divers' notes…"
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
            />
          </div>
        </div>

        <button type="submit" className="btn btn-primary">
          Save Hull Cleaning Report
        </button>
      </form>
    </div>
  );
};

export default HullCleaningNewReportPage;
